import {
  Components, Theme, breadcrumbsClasses, buttonBaseClasses, svgIconClasses, typographyClasses,
} from '@mui/material';
import { body2, body2Strong } from '../typography/jscss';
import { Content } from '../color';
import { Spacing2 } from '../spacing';

export const MuiBreadcrumbs: Components<Theme>['MuiBreadcrumbs'] = {
  styleOverrides: {
    root: {
      [`.${buttonBaseClasses.root}`]: {
        backgroundColor: 'transparent',
      },
      [`.${breadcrumbsClasses.separator}`]: {
        lineHeight: '20px',
        paddingRight: Spacing2,
        paddingLeft: Spacing2,
        border: 0,
        [`&:has(.${svgIconClasses.root})`]: {
          margin: 0,

        },
        [`.${svgIconClasses.root}`]: {
          width: 20,
          height: 20,
        },
      },
      [`.${breadcrumbsClasses.li}`]: {
        [`.${typographyClasses.root}`]: {
          display: 'flex',
          alignItems: 'center',
          ...body2,
          textDecoration: 'none',
          color: Content.variant,
          '&:hover': {
            textDecoration: 'underline',
            color: Content.main,
          },
          '&:active': {
            textDecoration: 'none',
            color: Content.main,
          },
          [`.${svgIconClasses.root}`]: {
            width: 20,
            height: 20,
            marginRight: Spacing2,
          },
        },
        [`&:last-child .${typographyClasses.root}`]: {
          pointerEvents: 'none',
          color: Content.main,
          textDecoration: 'none',
          ...body2Strong,
        },
      },
    },
  },
};
